export const SERVICE = 'ENERGIES'
